import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padded?: boolean;
}

export function Card({ children, className = '', padded = true }: CardProps) {
  return (
    <div
      className={`bg-surface border border-border rounded-card shadow-gp-sm ${padded ? 'p-3.5' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
